import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { catchError } from 'rxjs/operators';
import { AppConfigService } from 'src/app/app-config.service';
import { EndpointBuilderService } from 'src/app/shared/services/endpint-builder.service';
import { ApiEnum } from 'src/app/shared/enum/api.enum';
import { CommonService } from '../../common-service';
import { LookupResponse } from '../../responses/integration/lookup.response';

@Injectable({
  providedIn: 'root'
})
export class LookupService extends CommonService {

  constructor(private httpClient: HttpClient, configService:AppConfigService, private endpointBuilder: EndpointBuilderService) { super(configService); }

  public getLookup(): Observable<LookupResponse> {

    let uri = `Lookup`

    return this.httpClient.get<LookupResponse>(this.endpointBuilder.getEndpoint(ApiEnum.urlApiIntegration) + uri, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }
}